import React, { useEffect, useState } from "react";
import PersonalForm from "./PersonalForm";
import EducationInfo from "./EducationInfo";
import WorkInFormation from "./WorkInformation";
import { Button, Checkbox, Form, message, Modal, notification } from "antd";
import moment from "moment";
import { CALL_API } from "common/API";
import styled from "styled-components";
import axios from "axios";
import { SERVICE_URL,Initialvalues } from "common/Constants";
import { Spin } from 'antd';
import logo2 from "../../assets/tymeplushrlogo.svg";
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import WorkDetails from "./WorkDetails";
import dayjs from 'dayjs';
import ViewMore from "./ViewMore";

function AddUser({isSubmitted, setIsSubmitted}) {
  const [step, setStep] = useState(0);
  const [showLoader, toggleLoader] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  const [formValues, setFormValues] = useState({});
  const [userData, setUserData] = useState({});
  const [userDataModal, setUserDataModal] = useState(false);
  const [userDataModal1, setUserDataModal1] = useState(false);
  const [submitBtn, setSubmitBtn] = useState(false);
  const [form] = Form.useForm();
  const [supervisorListData, setSupervisorListData] = useState([]);
  const location = useLocation();
 

  const StyledButton = styled(Button)`
  margin: 10px;
  margin-left: 0px;
  background: #2d53da !important;
  border-radius: 5px;
  color: #fff !important;
  font-weight: bold;
  width: 100px;
   :active-focus{
   color: #fff !important;
   }

  &.disabled_btn {
    background: #d3d3d3cc !important;
    cursor: not-allowed;
    color: #fff !important;
    border: none;
  }
   
`;
const StyledModal = styled(Modal)`

.ant-modal-content { 
  display: contents;
  text-align: center;
  background: #8c8c8c;
  box-shadow: none;
}
`;
const StyledSuccessModal1 = styled(Modal)`
.success_p{
  font-size: 1rem;  
  text-align: center;
}
.ant-modal-body {
  font-weight: bold;
  padding: 20px 10px;
  
}
.ant-modal-footer {
  border-top: none;
  padding: 0px;
  margin: 0px;
}
.anticon-check-circle {
  font-size: 4rem;
  display: block;
  padding: 10px;
  color: #2CFF00;
}
`;
const StyleSubmitButton1 = styled(Button)`
  font-weight: bold;
  height: 40px;
  width: 45%;
  border-radius: 12px;
  color: #000000;
`;
const LogoContainer = styled.div`
  background:#1890ff;
  color: #fff;
  /* position: absolute; */
  top: 0;
  left: 0;
  .logo {
    width: 100%;
    max-width: 130px;
    margin: 0 auto;
    padding: 20px 15px 20px 15px;
    padding-bottom: 0px;
  }
  .logo2 {
    width: 100%;
    max-width: 115px;
    margin: 0 auto;
    padding: 10px;
  }

`;
const StyledSuccessModal = styled(Modal)`
.ant-modal-body {
  font-weight: bold;
  padding: 20px 10px;
  .loading-message {
    padding-left: 50px;
  }
}
.ant-modal-footer {
  border-top: none;
  padding: 0px;
  margin: 0px;
}
.anticon-check-circle {
  font-size: 4rem;
  display: block;
  padding: 10px;
  color: #2CFF00;
}
.buttons_container{
  display: flex;
  justify-content: center;
  gap: 1rem;
}
.modal_title{
  width:90%;
  margin: auto;
  text-align: center;
}
`;

const getMasterData = async () => {
  try {
    if(!isSubmitted){
      setDataLoading(true)
    }
    const queryParams = queryString.parse(location.search);  
    const response = await axios.get(`${SERVICE_URL}onboarded-users?userid=${queryParams.userid}`);
    const savedData = await axios.get(`${SERVICE_URL}onboarded-users/draft?userid=${queryParams.userid}`);
    let updatedSaved = {...response?.data?.response?.response?.user, ...savedData?.data?.response?.response};

    if(response.data.response.error === "User not found" &&  response.status === 200){
      notification.error({message: "No User Data Found"})
    }
    if(response?.data?.response?.response?.user?.onBoardingFormStatus === "0"){
      message.error("You have already updated your details");
      setDataLoading(false);
      setSubmitBtn(true);
      setUserData(updatedSaved);
      setSupervisorListData(response?.data?.response?.response?.supervisorList);
    }
    else{
      setUserData(updatedSaved);
      setSupervisorListData(response?.data?.response?.response?.supervisorList);
      setDataLoading(false)
    }
  } catch (error) {
    console.error('Error fetching master data:', error);
    notification.error({message: "No User Data Found"})
    setDataLoading(false);
  }
};
useEffect(()=>{ 
  getMasterData()
},[]);

const saveHandler = async()=>{
  setUserDataModal1(false);
  let values = form.getFieldsValue();
  try {
    toggleLoader(true);
    setDataLoading(true);

    const {
      user_id,
        start_date,
        password,
        gender,
        nationality,
        maritalstatus,
        overtime,
        salary,
        facerecognition,
        nssf,
        nssfFile,
        national_id,
        address,
        phoneno,
        companyname,
        jobtitle,
        professionalsince,
        hireddate,
        relevent,
        employeesponser,
        description,
        emergencycontactname,
        emergencycontactnumber,
        employeeid,
        initial,
        firstname,
        lastname,
        salutation,
        lastpromotionlevel,
        lastpromotiondate,
        educationdetails,
        workexperience,
        professionalcertifications,
        employementtype,
        probationenddate,
        probationstartdate,
        contractstartdate,
        contractenddate,
        practicaltrainings,
        dateofbirth,
        acceptTerms
    } = values;

    let userId = form.getFieldValue("user_id");
    let userIdWithoutDomain = "";
    if (userId && userId.includes("@")) {
      let splitUserId = userId.split("@");
      userIdWithoutDomain = splitUserId[0];
    } else {
      console.error("Invalid user ID format or user ID is undefined");
      // You can handle the error here, for example, by setting a default value or throwing an error
    }
    // let splitUserId = userId?.split("@");
    // let userIdWithoutDomain = splitUserId[0];
    const dobDate = new Date(dateofbirth);
    const currentDate = new Date();
    const agecalculte = currentDate.getFullYear() - dobDate.getFullYear();

    const workexperienceDetails = workexperience?.map((item) => {
      const { fromdate, todate,attachment, ...rest } = item;
      const formattedFromDate = fromdate
        ? dayjs(fromdate).format("YYYY-MM-DD")
        : "";
      const formattedToDate = todate
        ? dayjs(todate).format("YYYY-MM-DD")
        : "";
        const updatedAttachment = attachment?.map((att) => ({
          name: att?.name,
          uniqueId: att?.response?.uniqueId,
        }));
      return {
        ...rest,
        fromdate: formattedFromDate,
        todate: formattedToDate,
        attachment:updatedAttachment
      };
    });

    const transformedEducationDetails = educationdetails?.map((item) => {
      const { attachment, fromdate, todate, ...rest } = item;
      const formattedFromDate = fromdate
        ? dayjs(fromdate).format("YYYY-MM-DD")
        : "";
      const formattedToDate = todate
        ? dayjs(todate).format("YYYY-MM-DD")
        : "";
      const updatedAttachment = attachment?.map((att) => ({
        name: att?.name,
        uniqueId: att?.response?.uniqueId,
      }));
      return {
        ...rest,
        fromdate: formattedFromDate,
        todate: formattedToDate,
        attachment: updatedAttachment,
      };
    });

    const practicaltrainingsDetails = practicaltrainings?.map((item) => {
      const { fromdate, todate, ...rest } = item;
      const formattedFromDate = fromdate
        ? dayjs(fromdate).format("YYYY-MM-DD")
        : "";
      const formattedToDate = todate
        ? dayjs(todate).format("YYYY-MM-DD")
        : "";
      return {
        ...rest,
        fromdate: formattedFromDate,
        todate: formattedToDate,
      };
    });
    const professionalcertificationsDetails = professionalcertifications?.map(
      (item) => {
        const { attachment, fromdate, todate, ...rest } = item;
        const formattedFromDate = fromdate
          ? dayjs(fromdate).format("YYYY-MM-DD")
          : "";
        const formattedToDate = todate
          ? dayjs(todate).format("YYYY-MM-DD")
          : "";
        const updatedAttachment = attachment?.map((att) => ({
          name: att?.name,
          uniqueId: att?.response?.uniqueId,
        }));
        return {
          ...rest,
          fromdate: formattedFromDate,
          todate: formattedToDate,
          attachment: updatedAttachment,
        };
      }
    );
    let obj = {
      userid: user_id?.toLowerCase(),
        full_name: `${firstname} ${lastname}`,
        end_date: formValues?.start_date
          ? moment(formValues?.start_date?._d).format("YYYY-MM-DD")
          : "",
        start_date: start_date
          ? moment(start_date?._d).format("YYYY-MM-DD")
          : "",
        overtime_status: overtime,
        bandname: userData?.bandname,
        bandid: userData?.bandid,
        gender: gender,
        dateofbirth: dateofbirth
          ? moment(dateofbirth?._d).format("YYYY-MM-DD")
          : "",
        age: agecalculte,
        password: password,
        maritalstatus: maritalstatus,
        nationality: nationality,
        salary: salary,
        facerecognition: facerecognition,
        role_id: userData?.selectedRoleId,
        role_name: userData?.roleNames,
        nssf: nssf,
        national_id: national_id,
        phoneno: phoneno,
        address: address,
        permanentaddress: address,
        presentaddress: address,
        employementtype: employementtype,
        profile_url: userData?.profileurl,
        companyname: companyname,
        jobtitle: jobtitle,
        professionalsince: professionalsince
          ? moment(professionalsince?._d).format("YYYY-MM-DD")
          : "",
        hireddate: hireddate ? moment(hireddate?._d).format("YYYY-MM-DD") : "",
        employementtype: employementtype,
        probationstartdate: probationstartdate
          ? moment(probationstartdate?._d, "YYYY-MM-DD")
          : "",
        probationenddate: probationenddate
          ? moment(probationenddate?._d, "YYYY-MM-DD")
          : "",
        contractstartdate: contractstartdate
          ? moment(contractstartdate?._d, "YYYY-MM-DD")
          : "",
        contractenddate: contractenddate
          ? moment(contractenddate?._d, "YYYY-MM-DD")
          : "",
        relevant: relevent,
        employeesponser: employeesponser,
        statusname: userData?.statusname,
        status_id: userData?.statusid,
        jobdescription: description,
        emergencycontactname: emergencycontactname,
        emergencycontactnumber: emergencycontactnumber,
        baselocationid: userData?.baselocationid,
        basedepartmentid: userData?.basedepartmentid,
        employeeid: employeeid,
        initial: initial,
        firstname: firstname,
        lastname: lastname,
        salutation: salutation,
        lastpromotionlevel: lastpromotionlevel,
        lastpromotiondate: lastpromotiondate ? moment(lastpromotiondate) : "",
        educationdetails:
          educationdetails[0]?.institutename !== ""
            ? transformedEducationDetails
            : [],
        workexperience:
          workexperience[0]?.companyname !== "" ? workexperienceDetails : [],
        professionalcertifications:
          professionalcertifications[0]?.certificationtype !== ""
            ? professionalcertificationsDetails
            : [],
        practicaltrainings:
          practicaltrainings[0]?.organisationname !== ""
            ? practicaltrainingsDetails
            : [],
      onBoardingFormStatus : "0",
      acceptTerms: acceptTerms,
      clientid: userData?.clientid,
      method: "individualuserform",
    }

    const response = await CALL_API(`onboarded-users/draft`, "post", obj);
    
    toggleLoader(false);
    setDataLoading(false);
    
    if (response.code === "SUCCESS") {
      if (response?.message === "Please Upgrade Your Plan") {
        message.error(response?.message);
      } else {
        message.success("Details saved");
        setStep(0);
        setFormValues({});
      }
    }
  } catch (error) {
    console.error("An error occurred:", error);
  } 
}


  const goBack = () => {
    setStep(step - 1);
  };

  const handleSubmit =  (values) => {
    if(!submitBtn){
      setUserDataModal(true);
    }
    return false;      
  };

  const handleConfirmation = async () => {
    setUserDataModal(false);  // Close the modal
    await userDataUpdate(form.getFieldsValue()); 
  };
 
  
  const userDataUpdate = async (values) => {
    try {
      toggleLoader(true);
      setDataLoading(true);

      const {
        user_id,
        start_date,
        password,
        gender,
        nationality,
        maritalstatus,
        overtime,
        salary,
        facerecognition,
        nssf,
        national_id,
        address,
        phoneno,
        companyname,
        jobtitle,
        professionalsince,
        hireddate,
        relevent,
        employeesponser,
        description,
        emergencycontactname,
        emergencycontactnumber,
        employeeid,
        initial,
        firstname,
        lastname,
        salutation,
        lastpromotionlevel,
        lastpromotiondate,
        educationdetails,
        workexperience,
        professionalcertifications,
        employementtype,
        probationenddate,
        probationstartdate,
        contractstartdate,
        contractenddate,
        practicaltrainings,
        dateofbirth,
        acceptTerms,
      } = values;

      let userId = form.getFieldValue("user_id");
      let splitUserId = userId.split("@");
      const dobDate = new Date(dateofbirth);
      const currentDate = new Date();
      const agecalculte = currentDate.getFullYear() - dobDate.getFullYear();

      const workexperienceDetails = workexperience?.map((item) => {
        const { fromdate, todate, ...rest } = item;
        const formattedFromDate = fromdate
          ? dayjs(fromdate).format("YYYY-MM-DD")
          : "";
        const formattedToDate = todate
          ? dayjs(todate).format("YYYY-MM-DD")
          : "";
        return {
          ...rest,
          fromdate: formattedFromDate,
          todate: formattedToDate,
        };
      });

      const transformedEducationDetails = educationdetails?.map((item) => {
        const { attachment, fromdate, todate, ...rest } = item;
        const formattedFromDate = fromdate
          ? dayjs(fromdate).format("YYYY-MM-DD")
          : "";
        const formattedToDate = todate
          ? dayjs(todate).format("YYYY-MM-DD")
          : "";
        const updatedAttachment = attachment?.map((att) => ({
          name: att?.name,
          uniqueId: att?.response?.uniqueId,
        }));
        return {
          ...rest,
          fromdate: formattedFromDate,
          todate: formattedToDate,
          attachment: updatedAttachment,
        };
      });

      const practicaltrainingsDetails = practicaltrainings?.map((item) => {
        const { fromdate, todate, ...rest } = item;
        const formattedFromDate = fromdate
          ? dayjs(fromdate).format("YYYY-MM-DD")
          : "";
        const formattedToDate = todate
          ? dayjs(todate).format("YYYY-MM-DD")
          : "";
        return {
          ...rest,
          fromdate: formattedFromDate,
          todate: formattedToDate,
        };
      });
      const professionalcertificationsDetails = professionalcertifications?.map(
        (item) => {
          const { attachment, fromdate, todate, ...rest } = item;
          const formattedFromDate = fromdate
            ? dayjs(fromdate).format("YYYY-MM-DD")
            : "";
          const formattedToDate = todate
            ? dayjs(todate).format("YYYY-MM-DD")
            : "";
          const updatedAttachment = attachment?.map((att) => ({
            name: att?.name,
            uniqueId: att?.response?.uniqueId,
          }));
          return {
            ...rest,
            fromdate: formattedFromDate,
            todate: formattedToDate,
            attachment: updatedAttachment,
          };
        }
      );

      let obj = {
        user_id: user_id?.toLowerCase(),
        full_name: `${firstname} ${lastname}`,
        end_date: formValues?.start_date
          ? moment(formValues?.start_date?._d).format("YYYY-MM-DD")
          : "",
        start_date: start_date
          ? moment(start_date?._d).format("YYYY-MM-DD")
          : "",
        overtime_status: overtime,
        bandname: userData?.bandname,
        bandid: userData?.bandid,
        gender: gender,
        dateofbirth: dateofbirth
          ? moment(dateofbirth?._d).format("YYYY-MM-DD")
          : "",
        age: agecalculte,
        password: password,
        maritalstatus: maritalstatus,
        nationality: nationality,
        salary: salary,
        facerecognition: facerecognition,
        role_id: userData?.selectedRoleId,
        role_name: userData?.roleNames,
        nssf: nssf,
        national_id: national_id,
        phoneno: phoneno,
        address: address,
        permanentaddress: address,
        presentaddress: address,
        employementtype: employementtype,
        profile_url: userData?.profileurl,
        companyname: companyname,
        jobtitle: jobtitle,
        professionalsince: professionalsince
          ? moment(professionalsince?._d).format("YYYY-MM-DD")
          : "",
        hireddate: hireddate ? moment(hireddate?._d).format("YYYY-MM-DD") : "",
        employementtype: employementtype,
        probationstartdate: probationstartdate
          ? moment(probationstartdate?._d, "YYYY-MM-DD")
          : "",
        probationenddate: probationenddate
          ? moment(probationenddate?._d, "YYYY-MM-DD")
          : "",
        contractstartdate: contractstartdate
          ? moment(contractstartdate?._d, "YYYY-MM-DD")
          : "",
        contractenddate: contractenddate
          ? moment(contractenddate?._d, "YYYY-MM-DD")
          : "",
        relevant: relevent,
        employeesponser: employeesponser,
        statusname: userData?.statusname,
        status_id: userData?.statusid,
        jobdescription: description,
        emergencycontactname: emergencycontactname,
        emergencycontactnumber: emergencycontactnumber,
        baselocationid: userData?.baselocationid,
        basedepartmentid: userData?.basedepartmentid,
        employeeid: employeeid,
        initial: initial,
        firstname: firstname,
        lastname: lastname,
        salutation: salutation,
        lastpromotionlevel: lastpromotionlevel,
        lastpromotiondate: lastpromotiondate ? moment(lastpromotiondate) : "",
        educationdetails:
          educationdetails[0]?.institutename !== ""
            ? transformedEducationDetails
            : [],
        workexperience:
          workexperience[0]?.companyname !== "" ? workexperienceDetails : [],
        professionalcertifications:
          professionalcertifications[0]?.certificationtype !== ""
            ? professionalcertificationsDetails
            : [],
        practicaltrainings:
          practicaltrainings[0]?.organisationname !== ""
            ? practicaltrainingsDetails
            : [],
      onBoardingFormStatus : "0",
      acceptTerms: acceptTerms,
      method: "individualuserform",
      }

      const response = await CALL_API(`add-users/${userData?.clientid}`, "patch", obj);
      toggleLoader(false);
      setDataLoading(true);
      // form.resetFields();
      setIsSubmitted(true);
      setSubmitBtn(true);
      saveHandler()
      // window.localStorage.removeItem("token");
      // sessionStorage.removeItem("tokenTimestamp");
      if (response.code === "SUCCESS") {
        if (response?.message === "Please Upgrade Your Plan") {
          message.error(response?.message);
        } else {
          message.success(response?.message);
          setStep(0);
          setFormValues({});
        }
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  console.log('userdata--->',userData?.educationdetails)


  useEffect(() => {
    form.setFieldsValue({
      user_id: userData?.userid,
      password: userData?.password,
      gender: userData?.gender,
      dateofbirth: userData?.dateofbirth ? moment(userData?.dateofbirth, "YYYY-MM-DD") : null,
      maritalstatus: userData?.maritalstatus,
      nationality: userData?.nationality,
      start_date: userData?.startdate ? moment(userData?.startdate, "YYYY-MM-DD") : null,
      end_date: userData?.enddate ? moment(userData?.enddate) : "",
      bandid: userData?.bandid,
      overtime: userData?.overtimestatus,
      salary: userData?.salary,
      facerecognition: userData?.facerecognition,
      profile_url: userData?.profileurl != ("" || null || undefined) ? userData?.profileurl : null,
      role_id: userData?.roleid,
      nssf: userData?.nssf,
      national_id: userData?.national_id,
      address: userData?.address,
      employementtype: userData?.employementtype,
      phoneno: userData?.phoneno,
      companyname: userData?.companyname,
      jobtitle: userData?.jobtitle,
      professionalsince: userData?.professionalsince
        ? moment(userData?.professionalsince, "YYYY-MM-DD")
        : null,
      hireddate: userData?.hireddate ? moment(userData?.hireddate, "YYYY-MM-DD") : null,
      probationstartdate: userData?.probationstartdate
        ? moment(userData?.probationstartdate, "YYYY-MM-DD")
        : null,
      probationenddate: userData?.probationenddate
        ? moment(userData?.probationenddate, "YYYY-MM-DD")
        : null,
        contractstartdate: userData?.contractstartdate
        ? moment(userData?.contractstartdate, "YYYY-MM-DD")
        : null,
        contractenddate: userData?.contractenddate
        ? moment(userData?.contractenddate, "YYYY-MM-DD")
        : null,
      relevent: userData?.relevant,
      employeesponser: userData?.employeesponser,
      employeestatus: userData?.statusname,
      description: userData?.jobdescription,
      emergencycontactnumber: userData?.emergencycontactnumber,
      emergencycontactname: userData?.emergencycontactname,
      employeeid: userData?.employeeid,
      initial: userData?.initial,
      firstname: userData?.firstname,
      lastname: userData?.lastname,
      salutation: userData?.salutation,
      lastpromotionlevel: userData?.lastpromotionlevel,
      lastpromotiondate: userData?.lastpromotiondate
        ? moment(userData?.lastpromotiondate, "YYYY-MM-DD")
        : null,
      clientid: userData?.clientid,
      acceptTerms: userData?.acceptTerms,
        educationdetails: userData?.educationdetails ? userData?.educationdetails?.map(detail => ({
          institutename: detail.institutename,
          fromdate: detail.fromdate ? dayjs(detail.fromdate) : "",
          todate: detail.todate ? dayjs(detail.todate) : "",
          exambody: detail.exambody,
          awarded: detail.awarded,
          attachment: detail.attachment,
        })) : Initialvalues?.educationdetails,
        practicaltrainings: userData?.practicaltrainings ? userData?.practicaltrainings?.map(training => ({
          organisationname: training.organisationname,
          fromdate: training.fromdate ? dayjs(training.fromdate) : "",
          todate: training.todate ? dayjs(training.todate) : "",
          positionheld: training.positionheld,
          tasksperformed: training.tasksperformed,
        })) : Initialvalues?.practicaltrainings,
        professionalcertifications: userData?.professionalcertifications? userData?.professionalcertifications?.map(cert => ({
          certificationtype: cert.certificationtype,
          fromdate: cert.fromdate ? dayjs(cert.fromdate): "",
          todate: cert.todate ? dayjs(cert.todate) : "",
          remarks: cert.remarks,
          attachment: cert.attachment,
        })) : Initialvalues?.professionalcertifications,
        workexperience: userData?.workexperience? userData?.workexperience?.map(exp => ({
          companyname: exp.companyname,
          fromdate: exp.fromdate ? dayjs(exp.fromdate) : "",
          todate: exp.todate ? dayjs(exp.todate) : "",
          jobtitle: exp.jobtitle,
          relevant: exp.relevant,
          jobdescription: exp.jobdescription,
          // attachment: exp.attachment,
        })) : Initialvalues?.workexperience,
    });
  }, [userData]);

 
  const closeBtnHandler = ()=>{
    setIsSubmitted(false);
    setSubmitBtn(true)
    setDataLoading(false);
  }
  
  return (
    <>
      
        <LogoContainer className="mb-2 pt-3 pb-3">
            <div className="container">
              <img className="logo " src={logo2} alt="logo" />
            </div>
            {/* <div className="text-center ">
              <img className="logo2" src={logo2} alt="logo2" />
            </div> */}
        <h4 className="text-center pb-2">Employee Details form</h4>
        </LogoContainer>
     <div className="container">      
      <StyledModal title=""
            visible={dataLoading}
            centered
            closable={false}
            maskClosable={false}
            // width={350}
            footer={[]}
            onCancel={() => setDataLoading(false)}>
        <Spin size="large"/>
      </StyledModal>
      {/* <StepsProgress stepdata={stepdata} title="" step={step} /> */}
      <Form
        layout="vertical"      
        onFinish={handleSubmit}
        form={form}
         >
        <PersonalForm
          setStep={setStep}
          setFormValues={setFormValues}
          formValues={formValues}
          form={form}
        />
        <WorkDetails 
          setStep={setStep}
          supervisorList={supervisorListData}
          setFormValues={setFormValues}
          formValues={formValues}
          userData={userData}
          form={form}/>

         <EducationInfo
          goBack={goBack}
          setStep={setStep}
          setFormValues={setFormValues}
          formValues={formValues}
          form={form}
        /> 
        <WorkInFormation
          goBack={goBack}
          setStep={setStep}
          setFormValues={setFormValues}
          formValues={formValues}
          form={form}
        />
        {/* <BankInformation
          goBack={goBack}
          setFormValues={setFormValues}
          handleSubmit={handleSubmit}
          formValues={formValues}
          form={form}
          showLoader={showLoader}
          setSignUniqueId={setSignUniqueId}
        /> */}
         <Form.Item
        name="acceptTerms"
        className="ms-0"
        valuePropName="checked"
        rules={[
          {
            validator: (_, value) =>
              value ? Promise.resolve() : Promise.reject('You must accept the terms and conditions'),
          },
        ]}
      >
        <Checkbox>
        <ViewMore value={`By submitting this form, I confirm that the information provided is true.
I consent to having my personal details processed.
I agree that BDO East Africa and its affiliated units (as data processor and/or controller) may process my data as needed in the course of its operations and my employment/contract, in compliance with the data protection laws and all other applicable legislations/ regulations in relation to the personal data.
BDO commits to ensure necessary safeguards are in place during storage, processing, and/or transfer of confidential information.`} count={200} />
        </Checkbox>
      </Form.Item>
      <StyledButton
              type="primary"
              htmlType='button'
              onClick={()=>{
                if(!submitBtn){
                  setUserDataModal1(true)
                }}           
                }
              className={submitBtn? "disabled_btn" : ""}
          >
              Save
      </StyledButton>
      <StyledButton
              type="primary"
              htmlType='submit'        
              className={submitBtn? "disabled_btn" : ""}
          >
              Submit
      </StyledButton>
        
        <StyledSuccessModal
          title=""
          visible={userDataModal}
          centered
          closable={true}
          keyboard={true}
          maskClosable={true}
          // width={350}
          footer={[]}
          onCancel={() => setUserDataModal(false)}
        >
          <p className="modal_title mb-3">Please make sure that all this data is correct and genuine, as we consider this for BDO HR purposes.</p>
           <div className="buttons_container">
           <StyledButton
                type="primary"
                htmlType='button'
                onClick={() => setUserDataModal(false)}
            >
              Cancel
            </StyledButton>
            <StyledButton
                loading={showLoader}
                type="primary"
                htmlType='button'
                onClick={handleConfirmation}
            >
                Submit
            </StyledButton>
           </div>
        </StyledSuccessModal>
        <StyledSuccessModal
          title=""
          visible={userDataModal1}
          centered
          closable={true}
          keyboard={true}
          maskClosable={true}
          // width={350}
          footer={[]}
          onCancel={() => setUserDataModal1(false)}
        >
          <p className="modal_title mb-3">Are you sure want to save the details for later?</p>
           <div className="buttons_container">
           <StyledButton
                type="primary"
                htmlType='button'
                onClick={() => setUserDataModal1(false)}
            >
              Cancel
            </StyledButton>
            <StyledButton
                loading={showLoader}
                type="primary"
                htmlType='button'
                onClick={saveHandler}            >
                Yes
            </StyledButton>
           </div>
        </StyledSuccessModal>
        <StyledSuccessModal1
            title=""
            visible={isSubmitted}
            centered
            closable={false}
            keyboard={true}
            maskClosable={false}
            // width={350}
            footer={[]}
            onCancel={() => setIsSubmitted(false)}
          >
            <p className="success_p pb-2 px-2">Thank you for your valuable time in sharing the data. Please keep in touch with the BDO HR team if you have any concerns or queries.</p>
            <div className="text-center">
              <StyleSubmitButton1  type="primary" htmlType="button" onClick={closeBtnHandler}>
                Close
              </StyleSubmitButton1>
            </div> 
          
          </StyledSuccessModal1>
      </Form>        
    </div>
    </>
   
   
  );
}

export default AddUser;
